const styles = theme => ({
  container: {
    background: theme.palette.common.white,
    width: '375px',
    Height: 'auto',
    padding: '24px 32px',
    boxShadow: '0 16px 24px 0 rgba(0, 0, 0, 0.16)',
    zIndex: 1,
    position: 'relative',
    marginLeft: '-80px'
  },
  heroCardHeader: {
    fontWeight: '500',
    fontSize: '41px',
    lineHeight: 1.2,
    letterSpacing: '0.32px'
  },
  heroCardDescription: {
    lineHeight: 1.5,
    marginTop: '24px',
    position: 'relative',
    fontWeight: 500,
    letterSpacing: '0.24px',
    width: '349px',
    fontSize: '1.15rem'
  },
  heroButton: {
    marginTop: '15px',
    width: '85%',
    bottom: 0,
    marginBottom: '20px',
  }
})

export default styles
